import Vue from "vue";
import {store} from "./storage";
import {router} from "./router";
import MainHeader from "./modules/header/Header";
import { Swiper as SwiperClass, Lazy, Navigation } from 'swiper/core';
import mcFamilyTree from "./modules/family-tree/mcFamilyTree";
import {
    DatePicker,
    Dialog,
    Popover,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Input,
    Checkbox,
    Loading,
    Radio,
    RadioGroup,
    Table,
    TableColumn,
    TabPane,
    Collapse,
    CollapseItem,
    Tabs,
} from 'element-ui';
import width from "./mixins/width";
import VueScrollTo from 'vue-scrollto';
import {AppNotify} from './utils/app-notify';
import {Lang} from "./utils/lang";
import {DataLayer} from "./utils/data-layer";
import locale from "./mixins/locale";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

SwiperClass.use([Lazy, Navigation]);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popover);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(VueScrollTo);
Vue.use(Checkbox);
Vue.use(Loading.directive);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.mixin(width);
Vue.mixin(locale);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$optionsLoading = {customClass: 'loading', spinner: 'loading'};

Vue.use(getAwesomeSwiper(SwiperClass));
window.Vue = Vue;
window.axios = require('axios');
window.Vue.use(Lang);
window.Vue.use(DataLayer);

window.axios.interceptors.request.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.response.status === 403 && !window.laravel.user) || error.response.status === 401) {
        router.push({name: 'login'});
    }
    return Promise.reject(error);
});

window.Vue.use(AppNotify);

new Vue({
    el: '#tree',
    store,
    router,
    data: () => ({
        menu: false,
        windowWidth: window.innerWidth,
    }),
    components: {
        MainHeader, mcFamilyTree
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
});
